/**
 * WordPress dependencies
 */
import { store, getContext } from '@wordpress/interactivity';

store( 'photobooths/packages', {
	actions: {
		toggle: () => {
			const context = getContext();
			context.isOpen = ! context.isOpen;
			context.text = context.isOpen ? 'Show less' : 'Show more';
		},
	},
} );
